<section class="go-container">
  <go-card class="go-column go-column--100" id="implementing-table-actions">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Implementing Table Actions</h2>
      <go-copy cardId="implementing-table-actions" goCopyCardLink></go-copy>
    </ng-container>
    <ng-container go-card-content>
      <p class="go-body-copy">
        Table actions are a set of icon buttons and other tools meant to perform actions on the table or the data inside of it.
        In the table you can provide a series of components via content projection.
      </p>

      <code [highlight]="tableActions_html"></code>

      <p class="go-body-copy">
        For the table actions to appear, you must toggle them on by using <code class="code-block--inline">showTableActions</code>
      </p>
      <p class="go-body-copy">
        Also, the size of the button icons can be controlled via the binding <code class="code-block--inline">buttonSize</code>.
        The design guidelines suggest using <code class="code-block--inline">buttonSize="medium"</code>.
        For more details, you can refer to the Button Size section on the 
        <a routerLink="/ui-kit/icon-button">Icon Button documentation</a>.
      </p>
    </ng-container>
  </go-card>

  <go-table
    class="go-column go-column--100"
    [tableConfig]="tableConfig"
    tableTitle="Example of Table Actions"
    [showTableActions]="true">
    <ng-container go-table-actions>
      <go-icon-button buttonIcon="filter" buttonSize="medium"></go-icon-button>
      <go-icon-button buttonIcon="settings" buttonSize="medium"></go-icon-button>
    </ng-container>
    <go-table-column field="id" title="ID"></go-table-column>
    <go-table-column field="name.first" title="First Name"></go-table-column>
    <go-table-column field="name.last" title="Last Name"></go-table-column>
    <go-table-column field="email" title="Email"></go-table-column>
    <go-table-column field="gender" title="Gender"></go-table-column>
    <go-table-column field="ip_address" title="IP Address"></go-table-column>
  </go-table>
</section>
